import { WorkOrderRowsExportTypeVO } from "../../components/lang-download-file/lang-download-file.configuration";

export class ReportDownloadParameter {

  exportCustomTemplateType: number | null = null;
  templateLanguage: string | null = null;
  exportType : number | null = null;
  locationOid: number | null = null;
  handlingOid: number | null = null;
  packagingOid : number | null = null;
  workOrderOid : number | null = null;
  formTemplateOid : number | null = null;
  leadOid: number | null = null;
  action : string | null = null;
  labelDownload : string | null = null;
  directDownload = true;
  openInBrowser: boolean = false;
  rowType: WorkOrderRowsExportTypeVO | null = WorkOrderRowsExportTypeVO.All;
  /**
   * Forza il backend a generare il PDF in versione "Preventivo".
   * Quando null (default) il backend mantiene la sua logica preesistente,
   * quando true viene aggiunto il query param `Quotation=true` alla request.
   * Usato dal menu di download raggruppato: vedi WorkOrderDownloadMenuComponent.
   */
  Quotation: boolean | null = null;

  private constructor() {
  }

  public static create = () => new ReportDownloadParameter();

  setTemplateLanguage(value: string | null): ReportDownloadParameter {

    this.templateLanguage = value;
    return this;

  }

  setLocationOid(value: number | null): ReportDownloadParameter {

    this.locationOid = value;
    return this;

  }

  setHandlingOid(value: number | null): ReportDownloadParameter {

    this.handlingOid = value;
    return this;

  }

  setDirectDownload(value: boolean): ReportDownloadParameter {

    this.directDownload = value;
    return this;

  }

  setOpenInBrowser(value: boolean): ReportDownloadParameter {

    this.openInBrowser = value;
    return this;

  }

  setPackagingOid(value: number | null): ReportDownloadParameter {

    this.packagingOid = value;
    return this;

  }

  setAction(value: string | null): ReportDownloadParameter {

    this.action = value;
    return this;

  }

  setLabelDownload(value: string | null): ReportDownloadParameter {

    this.labelDownload = value;
    return this;

  }

  setWorkOrderOid(value: number | null): ReportDownloadParameter {

    this.workOrderOid = value;
    return this;

  }

  setLeadOid(value: number | null): ReportDownloadParameter {

    this.leadOid = value;
    return this;

  }

  setExportType(value: number | null): ReportDownloadParameter {

    this.exportType = value;
    return this;

  }

  setFormTemplateOid(value: number | null): ReportDownloadParameter {

    this.formTemplateOid = value;
    return this;

  }

  setRowType(value: WorkOrderRowsExportTypeVO | null): ReportDownloadParameter {

    this.rowType = value;
    return this;
  }

  /**
   * Forza il backend a generare il PDF in versione "Preventivo".
   * Quando null (default), il query param NON viene inviato e il backend
   * applica la sua logica preesistente.
   */
  setQuotation(value: boolean | null): ReportDownloadParameter {

    this.Quotation = value;
    return this;

  }

    setExportCustomTemplateType(value: number | null): ReportDownloadParameter {

    this.exportCustomTemplateType = value;
    return this;

  }

}
